import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import PusherPlugin from './utils/pusher'
import TranslatePlugin from './plugins/translate'
import Nt from './components/Nt.vue'

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.scss';
import './theme/custom.scss';

import 'lodash';

import * as IonComponents from '@ionic/vue';
import store from './store'
import {httpNoAuth, httpAuth} from './utils/axios';

import { datadogRum } from '@datadog/browser-rum';

if (process.env.VUE_APP_DD_APP_ID) {
  datadogRum.init({
    applicationId: process.env.VUE_APP_DD_APP_ID,
    clientToken: process.env.VUE_APP_DD_APP_KEY,
    site: 'datadoghq.com',
    service: 'assemble-livescores',
    env: process.env.VUE_APP_DD_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input'
  });
  
  datadogRum.startSessionReplayRecording();
}

const moment = require('moment-timezone');

const app = createApp(App)
  .use(store)
  .use(IonicVue)
  .use(PusherPlugin, {
    apiKey: process.env.VUE_APP_PUSHER_API_KEY,
    cluster: 'ap4',
  })
  .use(router)
  .use(TranslatePlugin);

app.component('nt', Nt);

// includes all ionic component
Object.keys(IonComponents).forEach(key => {
  if (/^Ion[A-Z]\w+$/.test(key)) {
    app.component(key, IonComponents[key]);
  }
});

app.config.globalProperties.$http = httpAuth;
app.config.globalProperties.$httpNoAuth = httpNoAuth;
app.config.globalProperties.$moment = moment;

// error handler
import { toastController, alertController } from '@ionic/vue';

import './registerServiceWorker'
app.config.globalProperties.$error = (errors) => {
  toastController
    .create({
      position: 'top',
      message: _.join(_.map(errors, e=> e.message), '\n'),
      duration: 1000
    }).then(toast => {
      toast.present();
    })
};

app.config.globalProperties.$success = (message = 'Successful') => {
  toastController
    .create({
      position: 'top',
      message: message,
      duration: 2000
    }).then(toast => {
      toast.present();
    })
};

app.config.globalProperties.$confirm = async (
  message = 'Are you sure you want to continue?', 
  onCancel = () => {}, 
  onConfirm = () => {} 
) => {
  const alert = await alertController
    .create({
      header: 'Alert',
      message,
      buttons: [
        {
          text: 'Cancel',
          cssClass: 'secondary',
          handler: onCancel,
        },
        {
          text: 'Confirm',
          handler: onConfirm
        },
      ],
    });
  await alert.present();
}

app.config.errorHandler = function(message = 'An error has occured') {
  toastController
    .create({
      position: 'top',
      message,
      duration: 2000
    }).then(toast => {
      toast.present();
    })
}

// Google Translate: initialise auto-translation for the configured language.
// Call this only when the active entity matches VUE_APP_NATIONAL_ID.
function initGoogleTranslate(lang) {
  if (!lang || window._googleTranslateActive) return;
  window._googleTranslateActive = true;

  // Set the Google Translate cookie so translation activates automatically
  document.cookie = 'googtrans=/en/' + lang + ';path=/';
  document.cookie = 'googtrans=/en/' + lang + ';path=/;domain=' + window.location.hostname;

  // Hidden container for Google Translate widget
  var el = document.createElement('div');
  el.id = 'google_translate_element';
  el.style.display = 'none';
  document.body.appendChild(el);

  // Hide Google Translate UI elements
  var style = document.createElement('style');
  style.textContent =
    '.goog-te-banner-frame, #goog-gt-tt, .goog-te-balloon-frame, ' +
    '.goog-tooltip, .goog-tooltip:hover { display: none !important; } ' +
    'body { top: 0 !important; } ' +
    '.goog-te-gadget { font-size: 0 !important; } ' +
    '.skiptranslate { display: none !important; }';
  document.head.appendChild(style);

  // Callback for Google Translate
  // eslint-disable-next-line no-undef
  window.googleTranslateElementInit = function() {
    // eslint-disable-next-line no-undef
    new google.translate.TranslateElement({
      pageLanguage: 'en',
      includedLanguages: lang,
      autoDisplay: false,
      // eslint-disable-next-line no-undef
      layout: google.translate.TranslateElement.InlineLayout.NONE
    }, 'google_translate_element');
  };

  // Load Google Translate script
  var script = document.createElement('script');
  script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
  document.body.appendChild(script);
}

router.isReady().then(() => {
  app.mount('#app');

  // Only activate Google Translate for the national entity (VUE_APP_NATIONAL_ID).
  // By the time router.isReady() resolves, the beforeEach guard has already
  // called getSlugBranding and populated entity._id in the store.
  const lang = process.env.VUE_APP_AUTO_TRANSLATE_LANG;
  if (lang && process.env.VUE_APP_NATIONAL_ID === '19') {
    initGoogleTranslate(lang);
  }
});